// extracted by mini-css-extract-plugin
export default {"Todos":"Todos_Todos__tuQ41"};